import React, { useState, useEffect } from 'react';
import {
    Breadcrumb, Layout, theme, Space, Form, Input, Button, Select,
    InputNumber, Col, Row, Switch, Spin, DatePicker
} from 'antd';
import { AlertError, AlertSuccess } from '../../usableclasses.js';
import axios from 'axios';
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../../appsettings.js';
import { Link, useNavigate } from "react-router-dom";

const { Content } = Layout;

const ProductRegistration = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");

    const [form] = Form.useForm();
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const [segments, setSegments] = useState([]);
    const [sectors, setSectors] = useState([]);
    const [uoms, setUoms] = useState([]);
    const [positions, setPositions] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchDropdowns();
    }, []);

    const fetchDropdowns = async () => {
        setLoading(true);
        try {
            const [
                catRes,
                brandRes,
                typeRes,
                segRes,
                secRes,
                uomRes,
                posRes
            ] = await Promise.all([
                axios.get(`${ApiURL}/master/category/dropdown`, { headers: { SystemAccessToken: TOKEN } }),
                axios.get(`${ApiURL}/master/brands/dropdown`, { headers: { SystemAccessToken: TOKEN } }),
                axios.get(`${ApiURL}/master/productstype/dropdown`, { headers: { SystemAccessToken: TOKEN } }),
                axios.get(`${ApiURL}/master/segment/dropdown`, { headers: { SystemAccessToken: TOKEN } }),
                axios.get(`${ApiURL}/master/sector/dropdown`, { headers: { SystemAccessToken: TOKEN } }),
                axios.get(`${ApiURL}/master/uom/dropdown`, { headers: { SystemAccessToken: TOKEN } }),
                axios.get(`${ApiURL}/master/position/dropdown`, { headers: { SystemAccessToken: TOKEN } })
            ]);

            setCategories(catRes.data || []);
            setBrands(brandRes.data || []);
            setProductTypes(typeRes.data || []);
            setSegments(segRes.data || []);
            setSectors(secRes.data || []);
            setUoms(uomRes.data || []);
            setPositions(posRes.data || []);
        } catch (err) {
            AlertError("Failed to load dropdowns.");
        } finally {
            setLoading(false);
        }
    };


    const onFinish = async (values) => {
        setLoading(true);
        try {
            const payload = {
                proUseAs: values.proUseAs,
                proSku: values.proSku,
                proName: values.proName,
                brandId: parseInt(values.brandId),
                catId: parseInt(values.catId),
                sectorId: parseInt(values.sectorId),
                proTypeId: parseInt(values.proType),
                segmentId: parseInt(values.segmentId),
                development: values.development,
                positionId: parseInt(values.positionId),
                proSize: values.proSize,
                uomId: parseInt(values.uomId),
                proCostPrice: parseFloat(values.proCostPrice || 0),
                proOfferPrice: parseFloat(values.proSalePrice),
                proStandardPrice: parseFloat(values.proStandardPrice),
                proIntroDate: values.proIntroduceDate ? values.proIntroduceDate.format('YYYY-MM-DD') : null,
                proDiscoDate: values.proDiscontinueDate ? values.proDiscontinueDate.format('YYYY-MM-DD') : null,
                proIsSale: values.proIsSale || false,
                proIsActive: values.proIsActive ?? true,
                proCreatedBy: UPDATED_BY
            };

            await axios.post(`${ApiURL}/products/create`, payload, {
                headers: { SystemAccessToken: TOKEN }
            });
            AlertSuccess('Product registered successfully!');
            form.resetFields();
            navigate('/master/productlist');
        } catch (error) {
            AlertError('Product registration failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px' }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item>Master</Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={"/master/productlist"}>Products</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Product Registration</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
                        <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
                            <div style={{ background: colorBgContainer, padding: 24, borderRadius: borderRadiusLG }}>

                                <h2>Product Registration</h2>
                                <Form form={form} layout="vertical" onFinish={onFinish}>
                                    <Row gutter={16}>
                                        <Col sm={24} lg={4}><Form.Item label="Use As" name="proUseAs" rules={[{ required: true, message: 'Use As is required' }]}><Select options={[{ value: 'Normal' }, { value: 'Combo' }]} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Code" name="proSku" rules={[{ required: true, message: 'Code is required' }]}><Input /></Form.Item></Col>
                                        <Col sm={24} lg={8}><Form.Item label="Product Name" name="proName" rules={[{ required: true, message: 'Product Name is required' }]}><Input /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Size" name="proSize" rules={[{ required: true, message: 'Size is required' }]}><Input /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="UOM" name="uomId" rules={[{ required: true, message: 'UOM is required' }]}><Select options={uoms.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col sm={24} lg={4}><Form.Item label="Brand" name="brandId" rules={[{ required: true, message: 'Brand is required' }]}><Select options={brands.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Category" name="catId" rules={[{ required: true, message: 'Category is required' }]}><Select options={categories.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Sector" name="sectorId" rules={[{ required: true, message: 'Sector is required' }]}><Select options={sectors.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Type" name="proType" rules={[{ required: true, message: 'Product Type is required' }]}><Select options={productTypes.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Segment" name="segmentId" rules={[{ required: true, message: 'Segment is required' }]}><Select options={segments.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col sm={24} lg={4}><Form.Item label="Development" name="development" rules={[{ required: true, message: 'Development is required' }]}><Select options={[{ label: "LOCAL", id: 1 }, { label: "INT", id: 2 }].map(x => ({ value: x.label, label: x.label }))} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Position" name="positionId" rules={[{ required: true, message: 'Position is required' }]}><Select options={positions.map(x => ({ value: x.id, label: x.label }))} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Introduce Date" name="proIntroduceDate" rules={[{ required: true, message: 'Introduce Date is required' }]}><DatePicker style={{ width: '100%' }} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Discontinue Date" name="proDiscontinueDate" rules={[{ required: true, message: 'Discontinue Date is required' }]}><DatePicker style={{ width: '100%' }} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="For Sale" name="proIsSale" valuePropName="checked"><Switch /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Active Status" name="proIsActive" valuePropName="checked" initialValue={true}><Switch defaultChecked /></Form.Item></Col>
                                    </Row>

                                    <Row gutter={16}>

                                        <Col sm={24} lg={4}><Form.Item label="Offer Price" name="proSalePrice" rules={[{ required: true, message: 'Sales Price is required' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Standard Price" name="proStandardPrice" rules={[{ required: true, message: 'Standard Price is required' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
                                        <Col sm={24} lg={4}><Form.Item label="Cost Price" name="proCostPrice" rules={[{ required: true, message: 'Cost Price is required' }]}><InputNumber min={0} style={{ width: '100%' }} /></Form.Item></Col>
                                        <Col sm={24} lg={4} style={{ textAlign: 'right', paddingTop: 30 }}>
                                            <Button type="primary" htmlType="submit" loading={loading} style={{ minWidth: '150px' }}>
                                                {loading ? "Registering..." : "Register Product"}
                                            </Button>
                                        </Col>
                                        <Col sm={24} lg={4} style={{ textAlign: 'right', paddingTop: 30 }}>
                                            <Button
                                                type="default"
                                                onClick={() => {
                                                    form.resetFields();
                                                    fetchDropdowns();
                                                }}
                                                style={{ minWidth: '150px' }}
                                            >
                                                Reset
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Space>
                    </div>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
}

export default ProductRegistration;
